var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('icon-base',{attrs:{"viewBox":"0 0 16 8"}},[_c(_vm.iconComponent,{tag:"component"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }